import { render, staticRenderFns } from "./utils-explainers-page.vue?vue&type=template&id=21ace7f2&scoped=true"
import script from "./utils-explainers-page.vue?vue&type=script&lang=js"
export * from "./utils-explainers-page.vue?vue&type=script&lang=js"
import style0 from "./utils-explainers-page.vue?vue&type=style&index=0&id=21ace7f2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ace7f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ace7f2')) {
      api.createRecord('21ace7f2', component.options)
    } else {
      api.reload('21ace7f2', component.options)
    }
    module.hot.accept("./utils-explainers-page.vue?vue&type=template&id=21ace7f2&scoped=true", function () {
      api.rerender('21ace7f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/muiutils/views/utils-explainers-page.vue"
export default component.exports